import { createContext } from "react";
import { FiltrosProdutos, Produto } from "../../types/Produto";

// Tipo para opções de select (categorias transformadas)
type SelectOption = { name: string; value: string };

export type ProdutosContextType = {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  newProductModal: boolean;
  setNewProductModal: React.Dispatch<React.SetStateAction<boolean>>;
  produtos: Produto[];
  filtros: FiltrosProdutos;
  setFiltros: React.Dispatch<React.SetStateAction<FiltrosProdutos>>;
  filtroPesquisaAux: string;
  setFiltroPesquisaAux: React.Dispatch<React.SetStateAction<string>>;
  produtosFiltrados: Produto[];
  categorias: SelectOption[];
  optionsAtivos: SelectOption[];
  optionsEstoque: SelectOption[];
  optionsVisualizacao: SelectOption[];
  optionsOrdenacao: SelectOption[];
  optionsTags: SelectOption[];
  init: () => void;
  // Novos métodos para paginação
  hasMore: boolean;
  fetchMore: () => Promise<void>;
  resetAndFetch: () => Promise<void>;
  loadingMore: boolean;
};

export const ProdutosContext = createContext<ProdutosContextType>(null!);
